import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import admin from './admin.js'

export default new Router({
	mode: 'history',
	// base: process.env.BASE_URL,
	base: '/',
	routes: [{
			path: '/',
			component: () => import('../views/home'),
			redirect: 'index',
			children: [{
					path: 'index',
					component: () => import('../views/index'),
				},
				{
					path: 'baseSituation',
					component: () => import('../views/baseSituation/home')
				},
				{
					path:'regulations',
					component: () => import('../views/regulations/home')
				},
				{
					path:'teachers',
					component: () => import('../views/teachers/home')
				},{
					path:'cooperation',
					component: () => import('../views/cooperation/home')
				},{
					path:'material',
					component: () => import('../views/material/home')
				},{
					path:'project',
					component: () => import('../views/project/home')
				},{
					path:'resource',
					component: () => import('../views/resource/home')
				}
			]
		},
		...admin,
	]
})